// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LightspeedOAuthCallbackPage__root___YuVju{max-width:36rem}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/settings/lightspeed/LightspeedOAuthCallbackPage.scss"],"names":[],"mappings":"AAAA,2CACE,eAAA","sourcesContent":[".root {\n  max-width: 36rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "LightspeedOAuthCallbackPage__root___YuVju"
};
export default ___CSS_LOADER_EXPORT___;
